<template>
  <div
    :class="{
      hero: true,
      'has-bg-img': true
    }"
    v-if="!isQuote"
  >
    <img
      class="image"
      :src="
        isStatic
          ? `https://static.porscheautoinsurance.com/images/${image}.${extension}`
          : require(`@/assets/img/homepage/${image}.${extension}`)
      "
      alt="Hero-Image"
    />
    <img
      class="hero-image-mobile"
      :src="
        isStatic
          ? `https://static.porscheautoinsurance.com/images/${image}.${extension}`
          : require(`@/assets/img/homepage/Mobile_${image}.${extension}`)
      "
      alt="Hero-Image-Mobile"
    />
    <div class="body">
      <div class="container title-container">
        <p
          :class="{
            title: true,
            'mobile-font-size': true,
            'is-sr-only': title_sr_only
          }"
          v-html="title"
        ></p>
        <p
          :class="{
            title: true,
            subtitle: true,
            'mobile-font-size': true,
            'is-sr-only': title_sr_only
          }"
          v-html="subtitle"
        ></p>
      </div>
    </div>
  </div>
  <div
    :class="{
      hero: true,
      'has-bg-img': true
    }"
    v-else
  >
    <img
      class="image"
      :src="require(`@/assets/img/${image}.${extension}`)"
      alt="Hero-Image"
    />
    <img
      class="hero-image-mobile"
      :src="require(`@/assets/img/${image}-Mobile.${extension}`)"
      alt="Hero-Image-Mobile"
    />
    <div class="body">
      <div class="container">
        <p
          :class="{
            title: true,
            'mobile-font-size': true,
            'is-sr-only': title_sr_only
          }"
          v-html="title"
        ></p>
        <p
          :class="{
            title: true,
            subtitle: true,
            'mobile-font-size': true,
            'is-sr-only': title_sr_only
          }"
          v-html="subtitle"
        ></p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Hero',
  data: () => ({
    img: ''
  }),
  props: {
    isQuote: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    title_sr_only: {
      type: Boolean,
      default: false
    },
    image: {
      type: String,
      required: true
    },
    extension: {
      type: String,
      required: true
    },
    isStatic: {
      type: Boolean,
      required: false,
      default: false
    },
    align: {
      type: String,
      default: 'left'
    }
  }
};
</script>
<style lang="scss" scoped>
.hero {
  position: relative;

  @media (max-width: 767px) {
    align-items: stretch;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  @media (max-width: 767px) and (orientation: landscape) {
    min-height: 19em;
    margin-top: 3rem;
  }
}

::v-deep .break {
  display: block;

  &.not-bold {
    font-family: $family-sans-serif;
    font-weight: 400;
  }
}

.image {
  @media (max-width: 480px) {
    display: none;
  }
  @media (min-width: 480px) {
    width: 100%;
    display: block;
  }
}

.hero-image-mobile {
  @media (min-width: 480px) {
    display: none;
  }
  display: block;
  width: 100%;
  height: auto;
}

.body {
  @media (max-width: 767px) {
    position: absolute;
    bottom: 0.5rem;
    width: 100%;
  }

  @media (min-width: 768px) {
    bottom: 2.5rem;
    position: absolute;
    width: 100%;
  }
}

.title,
.subtitle {
  color: $primary;
}

.padding_needed {
  padding: 0 2%;

  @media (max-width: 767px) {
    padding: 0;
  }
}

.has-bg-img {
  .image {
    max-height: 100vh;

    @media (min-width: 1025px) {
      object-fit: cover;
      height: auto;
    }
  }

  @media only screen and (min-width: 768px) and (max-width: 1000px) {
    height: unset;
  }
}

.title.subtitle {
  font-family: $family-sans-serif;
  margin: 0;
  font-size: 42px;
  line-height: 1.225;
  font-weight: 200;

  @media (min-width: 760px) {
    //margin: 0.5em 0 0;
    line-height: 26px;
  }
  @media (min-width: 768px) and (max-width: 991px) {
    margin-bottom: -15px;
  }
  @media (min-width: 992px) {
    line-height: 34px;
  }
  @media (min-width: 1200px) {
    font-size: 34px;
    line-height: 40px;
  }
}
.title {
  font-family: $family-sans-serif;
  margin-bottom: 0;
  line-height: calc(2.125ex + 6px);
  font-weight: 200;
  font-size: clamp(1.8rem, calc(1.32rem + 2.41vw), 4.21rem);

  @media only screen and (min-width: 840px) and (max-width: 1199px) {
    font-size: clamp(2.03rem, calc(1.31rem + 3.58vw), 5.61rem);
  }

  @media (min-width: 1200px) {
    font-size: clamp(2.28rem, calc(1.24rem + 4.7vw), 7.48rem);
  }

  @media (max-width: 760px) {
    position: relative;
    bottom: 0.5rem;
  }

  @media (max-width: 768px) and (orientation: landscape) {
    min-height: 19em;
    margin-top: 3rem;
  }
}

.mobile-font-size {
  @media (max-width: 479px) {
    font-size: 34px;
  }
}
</style>
